export enum ModeOfTransport {
    Car = "Car",
    Cycle = "Cycle",
    Walk = "Walk"
}